import { TypeProduct, TypeProductFields } from '@/core/generated-types';
import { decodeProductId } from '@/utils/helpers';
import { shopifyProductField } from '@/core/contentfulConfig';
import {
  getShopifyDomain,
  YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS,
} from '@/core/constants';

export function getShopifyProductId(product: TypeProduct) {
  let productIdKey = null;
  let productId = null;
  let shopifyProductId = null;

  if (!product) return null;

  if (product.fields?.isPlayKit) {
    return YOTPO_PLAYKIT_PROGRAM_PRODUCT_IDS[getShopifyDomain()];
  }

  productIdKey = shopifyProductField() as keyof TypeProductFields;
  productId = product.fields[productIdKey] as string | undefined;
  shopifyProductId = productId && decodeProductId(productId);

  return shopifyProductId;
}
